/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  BulkWorkflowRequest,
  CountAllPaginatedParams,
  FindAllByUserAndStatusPagedParams,
  HandleRequestPayload,
  HandleRequestWithOtpPayload,
  PaginatedResponseTicketDtoObject,
  PaginatedResponseTicketSlimDtoObject,
  TicketDto,
  TicketExecutorsByReference,
  TicketsFilterByReference,
  TicketsQuery,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiWorkflowController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-workflow-controller
   * @name GetSlimTicketsWithoutPagination
   * @request POST:/api/v1/workflow/tickets/slim/all
   */
  getSlimTicketsWithoutPagination = (data: TicketsQuery, params: RequestParams = {}) =>
    this.http.request<PaginatedResponseTicketSlimDtoObject, any>({
      path: `/v1/workflow/tickets/slim/all`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getSlimTicketsWithoutPaginationPath = '/v1/workflow/tickets/slim/all'
  static getSlimTicketsWithoutPaginationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-workflow-controller
   * @name FindAllByUserAndStatus
   * @request POST:/api/v1/workflow/tickets/paged
   */
  findAllByUserAndStatus = (data: TicketsQuery, params: RequestParams = {}) =>
    this.http.request<PaginatedResponseTicketDtoObject, any>({
      path: `/v1/workflow/tickets/paged`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static findAllByUserAndStatusPath = '/v1/workflow/tickets/paged'
  static findAllByUserAndStatusMethod = 'POST'
  /**
   * No description
   *
   * @tags api-workflow-controller
   * @name GetTicketExecutorsByReference
   * @request POST:/api/v1/workflow/tickets/executors/fetch
   */
  getTicketExecutorsByReference = (data: TicketsFilterByReference, params: RequestParams = {}) =>
    this.http.request<TicketExecutorsByReference, any>({
      path: `/v1/workflow/tickets/executors/fetch`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getTicketExecutorsByReferencePath = '/v1/workflow/tickets/executors/fetch'
  static getTicketExecutorsByReferenceMethod = 'POST'
  /**
   * No description
   *
   * @tags api-workflow-controller
   * @name HandleRequest
   * @request POST:/api/v1/workflow/request
   */
  handleRequest = (data: HandleRequestPayload, params: RequestParams = {}) =>
    this.http.request<TicketDto, any>({
      path: `/v1/workflow/request`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static handleRequestPath = '/v1/workflow/request'
  static handleRequestMethod = 'POST'
  /**
   * No description
   *
   * @tags api-workflow-controller
   * @name HandleBulkRequest
   * @request POST:/api/v1/workflow/request/bulk
   */
  handleBulkRequest = (data: BulkWorkflowRequest, params: RequestParams = {}) =>
    this.http.request<PaginatedResponseTicketDtoObject, any>({
      path: `/v1/workflow/request/bulk`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static handleBulkRequestPath = '/v1/workflow/request/bulk'
  static handleBulkRequestMethod = 'POST'
  /**
   * No description
   *
   * @tags api-workflow-controller
   * @name HandleRequestWithOtp
   * @request POST:/api/v1/workflow/request/2fa
   */
  handleRequestWithOtp = (data: HandleRequestWithOtpPayload, params: RequestParams = {}) =>
    this.http.request<TicketDto, any>({
      path: `/v1/workflow/request/2fa`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static handleRequestWithOtpPath = '/v1/workflow/request/2fa'
  static handleRequestWithOtpMethod = 'POST'
  /**
   * No description
   *
   * @tags api-workflow-controller
   * @name FindAllByUserAndStatusPaged
   * @request GET:/api/v1/workflow/tickets
   */
  findAllByUserAndStatusPaged = (
    query: FindAllByUserAndStatusPagedParams,
    params: RequestParams = {},
  ) =>
    this.http.request<TicketDto[], any>({
      path: `/v1/workflow/tickets`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static findAllByUserAndStatusPagedPath = '/v1/workflow/tickets'
  static findAllByUserAndStatusPagedMethod = 'GET'
  /**
   * No description
   *
   * @tags api-workflow-controller
   * @name FindById
   * @request GET:/api/v1/workflow/tickets/{id}
   */
  findById = (id: string, params: RequestParams = {}) =>
    this.http.request<TicketDto, any>({
      path: `/v1/workflow/tickets/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findByIdPath = '/v1/workflow/tickets/${id}'
  static findByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-workflow-controller
   * @name CountAllPaginated
   * @request GET:/api/v1/workflow/tickets/count
   */
  countAllPaginated = (query: CountAllPaginatedParams, params: RequestParams = {}) =>
    this.http.request<number, any>({
      path: `/v1/workflow/tickets/count`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static countAllPaginatedPath = '/v1/workflow/tickets/count'
  static countAllPaginatedMethod = 'GET'
}
